import React, {useState, useEffect} from "react";
import { X, ExternalLink, ListChecks} from "lucide-react"; // Make sure you have these icons

function SubsidyNotification() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    //wait 3 seconds after page loads
    const timer = setTimeout(() => {
        setIsVisible(true);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    //Remember that the user closed it and store it in local storage temporarily
    localStorage.setItem("hasSeenSubsidyParams", "true");
  };

  const handleCheckNow = () => {
    // Open the official URL in a new tab
    window.open("https://checkstatus.mykasih.net/sara2/checkstatus", "_blank", "noopener,noreferrer");
    handleClose(); // Close the notification after click 
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-slideUp">
      
      {/* Added a subtle gradient border to make it look 'premium' */}
      <div className="bg-white border-l-4 border-[#FF8C42] p-5 rounded-r-xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] max-w-sm flex gap-4 items-start relative">
        
        <button 
          onClick={handleClose}
          className="absolute -top-2 -right-2 bg-white text-gray-400 hover:text-gray-600 rounded-full p-1 shadow border border-gray-100 transition"
        >
          <X size={14} />
        </button>

        {/* Icon: TrendingUp suggests 'Growth' or 'Maximizing Value' */}
        <div className="bg-orange-50 p-3 rounded-full shrink-0">
          <ListChecks className="text-[#FF8C42] w-6 h-6" />
        </div>

        <div>
          {/* HEADLINE: Focus on VALUE */}
          <h4 className="font-bold text-gray-800 text-sm">
            Stretch Your SARA Subsidy
          </h4>
          
          {/* BODY: The "Why" - Connects the money to YOUR app */}
          <p className="text-xs text-gray-600 mt-2 leading-relaxed">
            Eligible for the MyKasih aid? <span className="font-semibold text-[#5A3E2B]">Use our AI to plan the perfect grocery list</span> and get more items for your monthly allowance.
          </p>

          {/* CTA: specific instruction */}
          <button 
            onClick={handleCheckNow}
            className="mt-3 w-full flex items-center justify-center gap-2 text-xs font-bold text-white bg-[#FF8C42] hover:bg-[#e67e3b] px-4 py-2.5 rounded-lg shadow-md hover:shadow-lg transition transform active:scale-95"
          >
            Check Eligibility Now
            <ExternalLink size={12} />
          </button>
        </div>

      </div>
    </div>
  );
}

export default SubsidyNotification;